export const _en = {
    name: {
        label: "Prefix"
    },
    longName: {
        label: "Name"
    },
    description: {
        label: "Description"
    },
    division: {
        label: "Division"
    },
    plane: {
        label: "Plane"
    },
    color: {
        label: "Color"
    },
    isExternalMarker: {
        label: "Is out of base"
    }
};

export const _fr = {
    name: {
        label: "Préfixe"
    },
    longName: {
        label: "Nom"
    },
    description: {
        label: "Description"
    },
    division: {
        label: "Service"
    },
    plane: {
        label: "Avion"
    },
    color: {
        label: "Couleur"
    },
    isExternalMarker: {
        label: "Hors base (les stages associés à ces préfixes / codes de stages s'effectueront hors des locaux AF)" 
    }
};